<div class="pipeline-timeline__header" *ngIf="visibleEvents.length && live">
  <span class="pipeline-timeline__live">
    <span class="pipeline-timeline__live-dot"></span> Live
  </span>
</div>

<div *ngIf="loading" class="pipeline-timeline__loading">
  <i class="fas fa-circle-notch fa-spin"></i> Loading timeline…
</div>

<div class="pipeline-timeline__empty" *ngIf="!loading && !visibleEvents.length">
  <i class="fas fa-inbox"></i>
  <span>{{ emptyMessage }}</span>
</div>

<ul class="pipeline-timeline" *ngIf="!loading && visibleEvents.length">
  <li
    *ngFor="let evt of visibleEvents"
    class="pipeline-timeline__item"
    [ngClass]="'pipeline-timeline__item--' + evt.level"
  >
    <span class="pipeline-timeline__dot"></span>
    <div class="pipeline-timeline__content">
      <div class="pipeline-timeline__meta">
        <span class="pipeline-timeline__time">{{ evt.created_at | date:'MMM d, h:mm:ss.sss a' }}</span>
        <span class="pipeline-timeline__level" [ngClass]="'pipeline-timeline__level--' + evt.level">
          {{ evt.level }}
        </span>
      </div>
      <div class="pipeline-timeline__message">{{ evt.message }}</div>
    </div>
  </li>
</ul>
